export const SEARCH_EVENTS_START = 'SEARCH_EVENTS_START';
export const SEARCH_EVENTS = 'SEARCH_EVENTS';
export const SEARCH_EVENTS_SUCCESS = 'SEARCH_EVENTS_SUCCESS';
export const SEARCH_EVENTS_FAIL = 'SEARCH_EVENTS_FAIL';

export const ADD_EVENT_START = 'ADD_EVENT_START';
export const ADD_EVENT = 'ADD_EVENT';
export const ADD_EVENT_SUCCESS = 'ADD_EVENT_SUCCESS';
export const ADD_EVENT_FAIL = 'ADD_EVENT_FAIL';
